export default {
  header: "Our menu",
  login_for_points: "Login for points",
  table: "Table {{id}}",
  buttons: {
    view_order: "View order",
    continue_to_menu: "Continue to menu",
  },
};
